import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { FlatFileManagementComponent } from './flat-file-management.component';
import { FlatFileActionsComponent } from './flat-file-actions.component';
import { FlatFileActionButtonComponent } from './flat-file-action-button.component';
import { FlatFileActionService, UploadFlatFileDialogService } from './upload-flat-file-dialog.service';
import { UploadFlatFileDialogComponent } from './upload-flat-file-dialog.component';
import { FlatFileClickableButtonComponent } from './flat-file-clickable-button.component';
import { AgGridModule } from 'ag-grid-angular';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { DataProviderService } from '../../tamalelibs/services/dataprovider.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AgGridModule,
        DropDownsModule,
        WidgetsModule,
        TooltipModule,
    ],
    declarations: [
        FlatFileManagementComponent,
        FlatFileActionsComponent,
        FlatFileActionButtonComponent,
        FlatFileClickableButtonComponent,
        UploadFlatFileDialogComponent,
    ],
    providers: [
        FlatFileActionService,
        DataProviderService,
        UploadFlatFileDialogService,
    ],
    exports: [
        FlatFileManagementComponent,
    ]
})
export class FlatFileModule { }
